// @module BTM.SEOFix.SEOFix
define('BTM.SEOFix.SEOFix.View'
,	[
	'btm_seofix_seofix.tpl'
	
	,	'BTM.SEOFix.SEOFix.SS2Model'
	
	,	'Backbone'
    ]
, function (
	btm_seofix_seofix_tpl
	
	,	SEOFixSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class BTM.SEOFix.SEOFix.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_seofix_seofix_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new SEOFixModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BTM.SEOFix.SEOFix.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.SEOFix.SEOFix.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
